import { useCallback } from 'react';

import Pagination from '@libComponents/Pagination';

import useAttendance, { SET_PAGE_NUMBER } from './useAttendanceProvider';
// import TablePaginationContainer from '@libComponents/table/TablePaginationContainer';
import { SET_ROWS_PER_PAGE_NUMBER } from 'dashboard/context.actionTypes';
import useMediaQuery from '@mui/material/useMediaQuery';

const _Pagination = () => {
    const [{ currentPage, totalPages, pageSize }, dispatch] = useAttendance();
    const matchesMedia = useMediaQuery('(max-width:391px)');


    const handlePageChange = useCallback(
        (event, value) => {
            dispatch({
                type: SET_PAGE_NUMBER,
                payload: value
            });
        },
        [dispatch]
    );
    const handleRowsPerPageChange = useCallback(
        (value) => {
            dispatch({
                type: SET_ROWS_PER_PAGE_NUMBER,
                payload: value
            });
        },
        [dispatch]
    );

    return (
        !!totalPages && (
            matchesMedia ? <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            sx={{ display: 'flex', justifyContent: 'center' }}
            isRowsPerPageVarient ={true}
            rowsPerPageProps = {{
                name: 'attendance',
                onChange: handleRowsPerPageChange,
                value: pageSize
            }}
            boundaryCount={1}
            siblingCount={0}
        /> : <Pagination
        count={totalPages}
        page={currentPage}
        onChange={handlePageChange}
        sx={{ display: 'flex', justifyContent: 'center' }}
        isRowsPerPageVarient ={true}
        rowsPerPageProps = {{
            name: 'attendance',
            onChange: handleRowsPerPageChange,
            value: pageSize
        }}
    />
        )
    );
};

export default _Pagination;
